var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('v-container',{staticClass:"py-5 mx-auto"},[_c('v-row',{attrs:{"justify":"center"}},[_c('v-col',{attrs:{"cols":"12"}},[_c('v-sheet',[_c('v-btn',{on:{"click":function($event){return _vm.onExport()}}},[_vm._v("Export Language")])],1)],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }